import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const InsuranceServiceSkeleton = () => {
  return (
    <div className={s.insuranceCard}>
      <div className={s.insuranceHeader}>
        <p></p>
        <Skeleton
          width={180}
          height={24}
        />
      </div>

      <div className={s.insuranceParams}>
        <Skeleton
          width={20}
          height={20}
        />

        <div className={s.insuranceParamsText}>
          <Skeleton
            width={60}
            height={20}
          />
          <Skeleton
            width={280}
            height={40}
          />
        </div>
      </div>
      <div className={s.insuranceParams}>
        <Skeleton
          width={20}
          height={20}
        />

        <div className={s.insuranceParamsText}>
          <Skeleton
            width={60}
            height={20}
          />
          <Skeleton
            width={280}
            height={40}
          />
        </div>
      </div>
      <div className={s.insuranceParams}>
        <Skeleton
          width={20}
          height={20}
        />

        <div className={s.insuranceParamsText}>
          <Skeleton
            width={60}
            height={20}
          />
          <Skeleton
            width={280}
            height={40}
          />
        </div>
      </div>

      <div className={s.insuranceDivider}></div>

      <div className={s.insuranceFooter}>
        <div className={s.leftCol}>
          <Skeleton
            width={45}
            height={20}
          />
          <Skeleton
            width={115}
            height={16}
          />
        </div>

        <Skeleton
          width={44}
          height={24}
        />
      </div>
    </div>
  )
}
